enum ButtonVariant {
    DEFAULT = 'contained',
    OUTLINED = 'outlined',
    TEXT = 'text',
}

export default ButtonVariant;